import { createAction } from 'redux-actions'
import * as types from 'Redux/Types/InboxTypes'

export const getInboxEmails = createAction(types.GET_INBOX_EMAILS)
export const getInboxEmailsFailed = createAction(types.GET_INBOX_EMAILS_FAILED)
export const getInboxEmailsSucceeded = createAction(types.GET_INBOX_EMAILS_SUCCEEDED)
